import { getJson, withMap } from '@rad/utility/http';
import { Instant, LocalDate, LocalDateTime, LocalTime, ZoneId } from '../utility/datetime';
export const fetchAppointments = (merchantId, range, startDate) => {
    const startLocalDate = typeof startDate === 'string' ? LocalDate.parse(startDate) : startDate;
    const finishLocalDate = (() => {
        switch (range) {
            case 'year': return startLocalDate.plusYears(1);
            case 'week': return startLocalDate.plusWeeks(1);
            case 'day': return startLocalDate.plusDays(1);
        }
    })();
    const boundary = (date) => LocalDateTime.of(date, LocalTime.MIDNIGHT).atZone(ZoneId.SYSTEM).toInstant().toString();
    const qs = new URLSearchParams({ 'start': boundary(startLocalDate), 'finish': boundary(finishLocalDate) });
    return withMap(getJson(`/merchants/${merchantId}/appointments?${qs.toString()}`), (xs) => xs.map((x) => (Object.assign(Object.assign({}, x), { 'appointment': Instant.parse(x.appointment) }))));
};
export const fetchAppointmentsClient = (merchantId, clientId, startDate) => withMap(fetchAppointments(merchantId, 'year', startDate), (appointments) => appointments.filter((x) => x.client.id === clientId));
